import type { LucideIcon } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  subtext?: string;
  trend?: { value: number; direction: 'up' | 'down'; label: string };
  icon?: LucideIcon;
  variant?: 'default' | 'accent' | 'green' | 'red' | 'success' | 'warning' | 'danger' | 'info';
  loading?: boolean;
}

export function StatCard({ title, value, subtext, trend, icon: Icon, variant = 'default', loading }: StatCardProps) {
  if (loading) {
    return (
      <div className="stat-card" style={{ opacity: 0.6 }}>
        <div style={{ height: 10, background: 'var(--border)', borderRadius: 4, width: '50%', marginBottom: 12 }} />
        <div style={{ height: 28, background: 'var(--border)', borderRadius: 4, width: '70%', marginBottom: 8 }} />
        <div style={{ height: 8, background: 'var(--border)', borderRadius: 4, width: '35%' }} />
      </div>
    );
  }

  const variantMap: Record<string, string> = { success: 'green', warning: 'accent', danger: 'red', info: 'accent' };
  const resolvedVariant = variantMap[variant] ?? variant;
  const cardClass = resolvedVariant === 'default' ? 'stat-card' : `stat-card ${resolvedVariant}`;

  return (
    <div className={cardClass}>
      {Icon && (
        <div style={{
          width: 32, height: 32, borderRadius: 8,
          background: 'var(--accent-bg)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 12,
        }}>
          <Icon size={16} color="var(--p600)" />
        </div>
      )}

      <div className="stat-label">{title}</div>
      <div className="stat-value mono">{value}</div>

      <div className="stat-sub">
        {trend && (
          <span className={`stat-delta ${trend.direction === 'up' ? 'up' : 'down'}`}>
            {trend.direction === 'up' ? '↑' : '↓'} {trend.value}%
          </span>
        )}
        {(subtext || trend?.label) && (
          <span>{subtext ?? trend?.label}</span>
        )}
      </div>
    </div>
  );
}
